const APP_ROUTES = {
  // Public Routes
  HOME: "/",
  LOGIN: "/login",

  // Dashboard
  DASHBOARD: "/dashboard",

  // Network
  NETWORK: "/network",

  // Explore
  EXPLORE: "/explore",

  // Entity Management
  ENTITY: "/entity",
  CREATE_GROUP: "/entity/create-group",
  GROUP_DETAILS: "/entity/group/:groupId",
  ENTITY_DETAILS: "/entity/:entityId",

  // Profiles
  PLAYER: "/player/:userId",
  COACH: "/coach/:userId",
  AGENT: "/agent/:userId",
  SCOUT: "/scout/:userId",
  OTHER_PROFILE: "/other/:userId",

  // Go Star
  GO_STAR: "/go-star",
  GO_STAR_QUERY: "/go-star/:query",

  // Search
  SEARCH: "/search",

  // Chat
  CHAT: "/chat",
  CHAT_DETAILS: "/chat/:chatId/:sendToID",

  // Events
  EVENTS: "/events",
  CREATE_EVENT: "/events/create",
  CREATE_EVENT_STEPS: "/events/create/:eventType",
  EVENT_CREATED: "/events/create/success",
  EVENT_DETAILS: "/events/:eventId",
  INVITE_PARTICIPANTS: "/events/:eventId/invite",

  // Not Found
  NOT_FOUND: "404",
  CATCH: "*",

  // Network Error
  NETWORK_ERROR: "network-error",

  // Payment
  PAYMENT: "/payment",
  PAYMENT_HOW_IT_WORKS: "/payment/how-it-works",
  PAYMENT_LINKS: "/payment/payment-links",
  CREATE_PAYMENT_LINK: "/payment/create-payment-link",
  CREATE_PAYMENT_ACCOUNT: "/payment/create-payment-account",
};

export default APP_ROUTES;
